import { Tooltip } from '@material-ui/core'
import { useEffect, useMemo, useRef, useState } from 'react'
import NodeCategories from '../../logic/mana/nodes/NodeCategories'

import AsteriskIcon from 'mdi-material-ui/Asterisk'
import FireIcon from 'mdi-material-ui/Fire'
import RotateOrbitIcon from 'mdi-material-ui/RotateOrbit'
import AxisArrowIcon from 'mdi-material-ui/AxisArrow'
import StarFourPointsIcon from 'mdi-material-ui/StarFourPoints'
import AccessPointIcon from 'mdi-material-ui/AccessPoint'
import SourceMergeIcon from 'mdi-material-ui/SourceMerge'
import PoundIcon from 'mdi-material-ui/Pound'
import TargetIcon from 'mdi-material-ui/Target'

import NodeSearch from './NodeSearch'

import styled from 'styled-components'
import { keyboard } from '../../input/keyboard'
import StyledIconButton from '../lookAndFeel/StyledIconButton'

const NodeInventoryRoot = styled.div`
	display: flex;
	gap: 8px;
`

export const TAB_ICONS = [
	["All", AsteriskIcon],
	[NodeCategories.Logistics, SourceMergeIcon],
	[NodeCategories.Element, FireIcon],
	[NodeCategories.Direction, RotateOrbitIcon],
	[NodeCategories.Force, AxisArrowIcon],
	[NodeCategories.Event, AccessPointIcon],
	[NodeCategories.Targeting, TargetIcon],
	[NodeCategories.Modifier, StarFourPointsIcon],
	[NodeCategories.Unique, PoundIcon],
]

export default function NodeInventory({ nodes = [] as any[], onChange = undefined as any, value = undefined as any }) {

	const [openTab, setOpenTab] = useState(undefined as any)
	const alignEl = useRef<any>()

	const currentNodes = useMemo<any[]>(() => {
		if (openTab === 'All') return nodes
		if (openTab) {
			return nodes.filter(node => node.category === openTab)
		}

		return []
	}, [openTab, nodes])

	useEffect(() => {

		const handleOpenHotkey = (event: any) => {
			if (keyboard.ctrlDown) {
				if (event.key === 'e' || event.key === 'p') {
					event.stopPropagation()
					event.preventDefault()

					setOpenTab('All')
					return false
				}
			}
		}

		document.addEventListener('keydown', handleOpenHotkey)

		return () => {
			document.removeEventListener('keydown', handleOpenHotkey)
		}
	}, [])

	return (
		<NodeInventoryRoot ref={alignEl}>

			{TAB_ICONS.map(([tabName, TabIcon]) => {
				return (
					<Tooltip title={tabName} key={tabName as string}>
						<StyledIconButton
							$selected={tabName === openTab}
							onClick={() => setOpenTab(tabName)}
							color="inherit"
						>
							{/* @ts-ignore */}
							<TabIcon />
						</StyledIconButton>
					</Tooltip>
				)
			})}

			<NodeSearch
				tab={openTab === 'All' ? '' : openTab}
				nodes={currentNodes}

				onClick={node => {
					onChange(node)
					setOpenTab(undefined)
				}}

				open={openTab !== undefined}
				onClose={() => setOpenTab(undefined)}
				anchorEl={alignEl.current}
			/>
		</NodeInventoryRoot>
	)
}
